import React, { useState, useEffect } from 'react';
import { Dropdown } from 'semantic-ui-react'
import ReadAxios from '../axiosComponent/read';


const MyProductsCat = ({
    field: { name },
    form: { setFieldValue },
    ...props
}) => {
    // const [contents, setcontents] = useState([])
    // const [isloading, setisloading] = useState(true)
    // useEffect(() => {
    //     let locations = ReadAxios({ url: 'skuMaster' }) || [];
    //     locations.then((res) => {
    //         setcontents(res.data.resultSet)
    //         setisloading(false)
    //     })
    // }, [])

    // let options = []
    // if (contents.length > 0) {
    //     contents.map((object, index) => {
    //         let temp = {}
    //         temp.key = index + 1
    //         temp.text = object.skuCode
    //         temp.value = object.skuCode
    //         return options[index] = temp
    //     })
    // }
    const [serviceCateogyList, setServiceCateogyList] = useState([]);

    useEffect(() => {
        getServiceCategory()
    }, []);

    const getServiceCategory = () => {
        ReadAxios({
            completeURL: `${process.env.REACT_APP_MASTER_API}/service_category`,
        }).then((result) => {
            let data = result.data.resultSet;
            let list = data.map((item, index) => {
                return {
                    key: item.serviceCategoryId,
                    text: props.showNameAndCode ? `${item.serviceCategory} (${item.serviceCategoryCode})` : item.serviceCategory,
                    value: item.serviceCategoryId,
                    raw: { ...item },
                };
            });
            setServiceCateogyList(list)
        })
            .catch((err) => { console.log(err) });
    };
    let options = serviceCateogyList;

    return (
        <Dropdown
            selection
            // loading={isloading}
            style={{ width: "100%" }}
            // search
            onChange={(value, data) => props.onChange ? props.onChange(data) : setFieldValue(name, data.value)}
            options={options}
            {...props}
        />

    )
}

export default MyProductsCat